var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub_title"},[_c('h2',{style:({ color: _vm.titleColor })},[_vm._t("title")],2),_c('div',{staticClass:"bg",style:({backgroundImage: `url(${_vm.bgurl})`,})})])
}
var staticRenderFns = []

export { render, staticRenderFns }